// @flow
import config from '../../config';
import { APIError, makeAPICall, redirectTo } from '../generalCreators';
import { updateCurrentBooking } from './currentBookingCreators';

export function getBookings(
  organisationId: number,
  excludeArchived: boolean = false
): any {
  return function(dispatch, getState) {
    const endpoint = '/bookings';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId:
          organisationId && organisationId !== 0 ? organisationId : '0',
        excludeArchived
      }
    };
    return makeAPICall(endpoint, options).then(
      data =>
        dispatch({ type: 'UPDATE_BOOKINGS', bookings: data.data.bookings }),
      error => dispatch(APIError(error, 'Error getting Bookings'))
    );
  };
}

export function getBooking(
  bookingId: number,
  organisationId: ?number,
  withSettings: ?boolean = true
): any {
  return function(dispatch, getState) {
    const endpoint = `/booking/${bookingId}`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId,
        withSettings
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        return response.data;
      },
      error => dispatch(APIError(error, 'Error getting Booking'))
    );
  };
}

export function getBookingAddresses(
  bookingId: number,
  organisationId: number,
  deleteOnFail: boolean
): any {
  return function(dispatch, getState) {
    const endpoint = `/booking/${bookingId}/addresses`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId,
        deleteOnFail: deleteOnFail
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        if (response.data.message) {
          return response.data;
        } else {
          const csv = response.data;
          return csv;
        }
      },
      error => dispatch(APIError(error, 'Error getting Booking Addresses'))
    );
  };
}

export function addBooking(
  booking: Object,
  organisationId: number,
  context: string,
  redirect: boolean
): any {
  return function(dispatch, getState) {
    const endpoint = '/bookings';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      },
      data: booking
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const newBookingId = response.data.id;
        dispatch(getBookings(organisationId));
        dispatch(updateCurrentBooking(newBookingId, organisationId));
        if (redirect) {
          redirectTo(
            `/${context}/${organisationId}/bookings/${newBookingId}/map`
          );
        }
        return response;
      },
      error => dispatch(APIError(error, 'Error creating Booking'))
    );
  };
}

export function updateBooking(
  booking: Object,
  context: string,
  redirect: boolean
): any {
  return function(dispatch, getState) {
    const organisationId = booking.organisationId;
    const endpoint = `/booking/${booking.id}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      },
      data: booking
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getBooking(organisationId));
        dispatch(updateCurrentBooking(booking.id, organisationId));
        if (redirect) {
          redirectTo(
            `/${context}/${organisationId}/bookings/${booking.id}/map`
          );
        }
        return response;
      },
      error => dispatch(APIError(error, 'Error updating Booking'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/bookings/basicCreators.js